import { MODE } from '@/env'
import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { useMemo } from 'react'

type Mode = 'development' | 'staging' | 'production-non-store' | 'production'

type Access = 'internal' | 'disabled'

type FlagCondition = Partial<Record<Mode, Access>>

const INTERNAL_DOMAIN = 'datahive.ai'

const FLAGS = {
  nectarMission: { staging: 'disabled' }
} as const satisfies Record<string, FlagCondition>

export type FeatureFlag = keyof typeof FLAGS

function isInternalUser(email: string | undefined): boolean {
  return !!email && email.endsWith(`@${INTERNAL_DOMAIN}`)
}

function resolveFlag(flag: FlagCondition, email?: string): boolean {
  const access = flag[MODE as Mode]
  if (access === 'disabled') return false
  if (access === 'internal') return isInternalUser(email)
  return true
}

export function useFeatureFlag(flag: FeatureFlag): boolean {
  // const { data: user } = useFetchUser(true)
  return useMemo(() => resolveFlag(FLAGS[flag] /* ,  user?.email */), [flag /* , user?.email */])
}

export function useFeatureFlags(): Record<FeatureFlag, boolean> {
  const { data: user } = useFetchUser(true)
  return useMemo(() => {
    const entries = Object.entries(FLAGS) as [FeatureFlag, FlagCondition][]
    return Object.fromEntries(entries.map(([key, condition]) => [key, resolveFlag(condition, user?.email)])) as Record<
      FeatureFlag,
      boolean
    >
  }, [user?.email])
}
